import { withErrorBoundary } from "./ErrorBoundary";
export default withErrorBoundary;
